module.exports = __webpack_public_path__ + "img/手表-5.d92af37c.png";